import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {IUser, User} from "../../features/users/user";
import {Model} from "../../features/home-models/home-model";
import {IModel} from "../../features/home-models/home-model.interfaces";

@Injectable({
  providedIn: 'root'
})
export class ApiUsersService extends ApiService{
  private readonly url = `${environment.api.baseUrl}/users`;

  getMe(): Observable<User> {
    const url = `${this.url}/me`;
    return this.get<IUser>(url).pipe(
        map((u: IUser) => new User(u))
    );
  }

  getUsers(): Observable<User[]> {
    return this.get<IUser[]>(this.url).pipe(
        map((usersData: IUser[]) => {
          return usersData.map(userData => new User(userData));
        })
    );
  }
}
